import { Pipe, PipeTransform } from '@angular/core';
import { DropDownItem } from '../../../../../models/shared/stylesheet/drop-down-item';

/**
 * Resolves whether an option is the keyboard-highlighted one.
 *
 * `highlightedIndex` indexes the component's flat interactive list — the optional Reset row
 * followed by every *enabled* option across *every* group. The template renders group by group, so
 * its `*ngFor` index is neither global nor gap-free: it restarts at 0 for each group and counts
 * disabled options the flat list skips. Comparing the two directly highlights the wrong row (or
 * none). Matching on item identity avoids reconciling the two index spaces at all.
 */
@Pipe({
  name: 'dropdownItemHighlighted',
  standalone: true
})
export class DropdownItemHighlightedPipe implements PipeTransform {
  public transform(
    item: DropDownItem,
    highlightedIndex: number,
    interactiveItems: readonly (DropDownItem | 'reset')[] | null
  ): boolean {
    if (highlightedIndex < 0 || !interactiveItems?.length) {
      return false;
    }
    return interactiveItems[highlightedIndex] === item;
  }
}
